import React from 'react'

function Integrations() {
  return (
    <>
    
    </>
  )
}

export default Integrations